export default __webpack_public_path__ + "static/media/arrowRight.f3dca7d9.svg";